import { IconArrowRight } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type IViewActionIconProps = Omit<IBasicActionIconProps, 'children'>;

const DefaultProps: Partial<IViewActionIconProps> = {
  color: 'blue',
};

/** @registry Blue "view" action icon (arrow-right symbol) built on BasicActionIcon. */
export const ViewActionIcon = React.forwardRef<
  HTMLButtonElement,
  IViewActionIconProps
>((props, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      <IconArrowRight size={20} />
    </BasicActionIcon>
  );
});
ViewActionIcon.displayName = 'ViewActionIcon';
